import React from 'react';

// YouBuild logo: three stacked blocks forming a small Y.
// Uses brand indigo for the mark, and inherits text color for the wordmark.
const Logo = ({ size = 28 }) => {
  return (
    <div className="flex items-center gap-2">
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="YouBuild"
      >
        <rect x="3" y="5" width="9" height="9" rx="2" fill="#4F46E5" opacity="0.4" />
        <rect x="20" y="5" width="9" height="9" rx="2" fill="#4F46E5" opacity="0.7" />
        <rect x="11.5" y="18" width="9" height="9" rx="2" fill="#4F46E5" />
      </svg>
      <span
        className="text-[19px] font-semibold tracking-tight"
        style={{ color: 'inherit', letterSpacing: '-0.01em' }}
      >
        You<span className="font-normal opacity-70">Build</span>
      </span>
    </div>
  );
};

export default Logo;
